<template>
    <span :class="cssClass" v-show="visible">
        <cogi-label :required="required" label="SelectionnerUnOuPlusieursModeles" />

        <cogi-modelehlm
            :visible="model.utiliseProgrammeHlm ?? false"
            cssClass="cogi-subtitle grid"
            label="HlmPslPrive"
            v-model="model.estHlmPslPrive"
            :hasError="modeleHabitationHasError()" />

        <cogi-modelecoop
            :visible="model.utiliseProgrammeCoop ?? false"
            :utiliseAtelierFederationCoop="model.utiliseAtelierFederationCoop!"
            :culture="model.culture!"
            cssClass="cogi-subtitle grid"
            label="Coop"
            v-model="model.coop!"
            :hasError="modeleHabitationHasError()"
            :sourceItemsResponsabiliteCoop="sourceItemsResponsabiliteCoop"
            :sourceItemsServiceDesires="sourceItemsServiceDesires"
            :sourceItemsImplicationOrganisme="sourceItemsImplicationOrganisme" />

        <cogi-modeleobnl
            :visible="model.utiliseProgrammeObnl ?? false"
            :culture="model.culture!"
            cssClass="cogi-subtitle grid"
            label="Obnl"
            v-model="model.obnl!"
            :hasError="modeleHabitationHasError()"
            :sourceItemsServiceDesires="sourceItemsServiceDesires" />
    </span>
</template>
<script setup lang="ts">
    import { ref, watch, computed } from 'vue'
    import CogiModelecoop from './CogiModelecoop.vue'
    import CogiModeleobnl from './CogiModeleobnl.vue'
    import CogiModelehlm from './CogiModelehlm.vue'
    import CogiLabel from './CogiLabel.vue'
    import type { del } from '../../../clients/delclient'
    import type DemandeEnLigneVM from '../DemandeEnLigneVM'

    interface IPropsModeleHabitation {
        required: boolean
        label?: string
        cssClass: string
        valideNow: boolean
        sourceItemsImplicationOrganisme: del.ListItem[]
        sourceItemsServiceDesires: del.ListItem[]
        sourceItemsResponsabiliteCoop: del.ListItem[]
        visible: boolean
    }

    const props = withDefaults(defineProps<IPropsModeleHabitation>(), {
        required: false,
        label: '',
        cssClass: '',
        valideNow: false,
        visible: true,
    })

    const model = defineModel<DemandeEnLigneVM>({ required: true })

    const hasError = ref(false)

    const emit = defineEmits<{
        validated: [boolean]
    }>()

    const modeleHasData = computed(() => {
        return model.value.estHlmPslPrive || model.value.coop!.estSelectionne || model.value.obnl!.estSelectionne
    })

    function validate() {
        hasError.value = props.visible ? !modeleHasData.value : false
        emit('validated', hasError.value)
    }

    function modeleHabitationHasError() {
        let hasCurrentError = hasError.value && !modeleHasData.value
        if (!hasCurrentError) hasError.value = false
        return hasCurrentError
    }

    watch(
        () => props.valideNow,
        newValue => {
            if (newValue) validate()
        },
    )
</script>
